import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { fetchJobTitles } from '../../../../utils/redux_store/features/job_title_reducer';
import { fetchSkills } from '../../../../utils/redux_store/features/skill_reducer';
import { fetchSubSkills } from '../../../../utils/redux_store/features/subskill_reducer';
import { RootState, store } from '../../../../utils/redux_store/store';

export const useAssessmentFramework = () => {
  const [activeTab, setActiveTab] = useState<number>(0);

  const skills = useSelector((state: RootState) => state.skills);
  const subSkills = useSelector((state: RootState) => state.subSkills);
  const jobTitlesState = useSelector((state: RootState) => state.jobTitles);

  const skillsList = skills?.skillsList || [];
  const subSkillList = subSkills?.subSkillsList || [];
  const jobTitles = jobTitlesState?.jobTitlesList || [];

  useEffect(() => {
    if (skills?.loading === 'idle') {
      store.dispatch(fetchSkills());
    }
    if (subSkills?.loading === 'idle') {
      store.dispatch(fetchSubSkills());
    }
    if (jobTitlesState?.loading === 'idle') {
      store.dispatch(fetchJobTitles());
    }
  }, [skills?.loading, subSkills?.loading, jobTitlesState?.loading]);

  const isLoading =
    activeTab === 0
      ? skills?.loading === 'pending' || subSkills?.loading === 'pending'
      : jobTitlesState?.loading === 'pending';

  return {
    activeTab,
    setActiveTab,
    isLoading,
    skillsList,
    subSkillList,
    jobTitles,
  };
};
